<figure *transloco="let t" class="footer-icons">
    <svg-icon 
        [key]="iconKey" 
        [ngClass]="{'footer-icons__icon--alert' : alert}"
        [attr.title]="t(tooltip)"
        class="footer-icons__icon--display">
    </svg-icon>
    <p *ngIf="label" class="footer-icons__text">{{label}}</p>
</figure>
